/* eslint-disable no-use-before-define */
import globalService from '../../services/GlobalServices';
import GlobalTypes from '../types/GlobalTypes';

//* get all Status items
function getClientStatus() {
  return async (dispatch) => {
    dispatch({ type: GlobalTypes.GET_CLIENT_STATUS_REQUEST });
    try {
      const res = await globalService.getClientStatus();
      dispatch({
        type: GlobalTypes.GET_CLIENT_STATUS_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: GlobalTypes.GET_CLIENT_STATUS_ERROR,
          error: error.response
        });
      }
      //
    }
  };
}
//* get all country list items
function getCountryStatus() {
  return async (dispatch) => {
    dispatch({ type: GlobalTypes.GET_COUNTRY_REQUEST });
    try {
      const res = await globalService.getCountryStatus();
      dispatch({
        type: GlobalTypes.GET_COUNTRY_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: GlobalTypes.GET_COUNTRY_ERROR,
          error: error.response
        });
      }
      //
    }
  };
}

//* get all State list items
function getStateStatus(countryId) {
  return async (dispatch) => {
    dispatch({ type: GlobalTypes.GET_STATE_REQUEST });
    try {
      const res = await globalService.getStateStatus(countryId);
      dispatch({
        type: GlobalTypes.GET_STATE_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: GlobalTypes.GET_STATE_ERROR,
          error: error.response
        });
      }
      //
    }
  };
}

//* Load more notifications for infinite scroll
function loadMoreNotifications(page) {
  return async () => {
    // Don't dispatch loading state to avoid interfering with main notifications state
    try {
      const res = await globalService.getAllNotifications(page);
      return res.data;
    } catch (error) {
      console.error('Error loading more notifications:', error);
      throw error;
    }
  };
}

//* get all Address list items
function getAddress() {
  return async (dispatch) => {
    dispatch({ type: GlobalTypes.GET_ADDRESS_REQUEST });
    try {
      const res = await globalService.getAddress();
      dispatch({
        type: GlobalTypes.GET_ADDRESS_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: GlobalTypes.GET_ADDRESS_ERROR,
          error: error.response
        });
      }
      //
    }
  };
}

//* get all Status items
function getStatus(module) {
  return async (dispatch) => {
    dispatch({ type: GlobalTypes.GET_STATUS_REQUEST });
    try {
      const res = await globalService.getStatus(module);
      dispatch({
        type: GlobalTypes.GET_STATUS_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: GlobalTypes.GET_STATUS_ERROR,
          error: error.response
        });
      }
      //
    }
  };
}

//* get all Notifications items
function getAllNotifications(page, search = '', status = '') {
  return async (dispatch) => {
    dispatch({ type: GlobalTypes.GET_ALL_NOTIFICATIONS_REQUEST });
    try {
      const res = await globalService.getAllNotifications(page, search, status);
      dispatch({
        type: GlobalTypes.GET_ALL_NOTIFICATIONS_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: GlobalTypes.GET_ALL_NOTIFICATIONS_ERROR,
          error: error.response
        });
      }
    }
  };
}

function readNotification(code) {
  return async (dispatch) => {
    dispatch({ type: GlobalTypes.READ_NOTIFICATION_REQUEST });
    try {
      const res = await globalService.readNotification(code);
      dispatch({
        type: GlobalTypes.READ_NOTIFICATION_SUCCESS,
        payload: res.data.data
      });
      setTimeout(() => dispatch(globalAction.getAllNotifications()), 500);
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: GlobalTypes.READ_NOTIFICATION_ERROR,
          error: error.response
        });
      }
    }
  };
}

function readAllNotifications() {
  return async (dispatch) => {
    dispatch({ type: GlobalTypes.READ_ALL_NOTIFICATIONS_REQUEST });
    try {
      const res = await globalService.readAllNotifications();
      dispatch({
        type: GlobalTypes.READ_ALL_NOTIFICATIONS_SUCCESS,
        payload: res.data.data
      });
      setTimeout(() => dispatch(globalAction.getAllNotifications()), 500);
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: GlobalTypes.READ_ALL_NOTIFICATIONS_ERROR,
          error: error.response
        });
      }
    }
  };
}

const globalAction = {
  getClientStatus,
  getCountryStatus,
  getStateStatus,
  getAddress,
  getStatus,
  getAllNotifications,
  loadMoreNotifications,
  readNotification,
  readAllNotifications
};

export default globalAction;
